<script setup>
import OT from "@opentok/client";
import axios from "axios";
import { onMounted, ref, defineProps, defineExpose } from "vue";

const API_URL = process.env.VUE_APP_API_URL;
const accessToken = localStorage.getItem("access_token");
const config = {
  headers: {
    Authorization: `Bearer ${accessToken}`,
  },
};
let session = null;

const props = defineProps({
  solicitud: Object,
});

function initializeSession(apiKey, sessionId, token) {
  session = OT.initSession(apiKey, sessionId);

  // Suscribirse a un nuevo stream creado
  session.on("streamCreated", (event) => {
    const subscriberOptions = {
      insertMode: "append",
      width: "100%",
      height: "100%",
    };
    session.subscribe(
      event.stream,
      "subscriber",
      subscriberOptions,
      (error) => {
        if (error) {
          console.error("Error al suscribirse al stream:", error);
        } else {
          console.log("Suscripción exitosa al stream");
        }
      }
    );
  });

  // Inicializar el publicador
  const publisherOptions = {
    insertMode: "append",
    width: "100%",
    height: "100%",
  };
  const publisher = OT.initPublisher("publisher", publisherOptions, (error) => {
    if (error) {
      console.error("Error al inicializar el publicador:", error);
    }
  });

  // Conectar a la sesión
  session.connect(token, (error) => {
    if (error) {
      console.error("Error al conectar a la sesión:", error);
    } else {
      session.publish(publisher, (publishError) => {
        if (publishError) {
          console.error("Error al publicar en la sesión:", publishError);
        } else {
          console.log("Publicación exitosa en la sesión");
        }
      });
    }
  });
}

function endCall() {
  if (session && session.isConnected()) {
    session.disconnect();
    console.log("Call ended");
  }
}

defineExpose({
  endCall,
});

onMounted(() => {
  const resultado = ref(null);
  const error = ref(null);

  // Realizar la solicitud para iniciar videollamada
  axios
    .get(`${API_URL}inasistencia/init-call/${props.solicitud.id}`, config)
    .then((response) => {
      // Verificar si la solicitud fue exitosa
      if (response.status === 200) {
        initializeSession(
          response.data.credentials.apiKey,
          response.data.credentials.session,
          response.data.credentials.token_med
        );
      } else {
        error.value =
          "Error al actualizar el registro del solicitud: " +
          response.statusText;
      }
    })
    .catch((err) => {
      console.error("Error en la solicitud de inicialización de llamada:", err);
      error.value = "Error al intentar conectar a la llamada.";
    });

  return { resultado, error };
});
</script>

<template>
  <div class="row mb-2">
    <div class="col-12 col-md" id="publisher"></div>
    <div class="col-12 col-md" id="subscriber"></div>
  </div>
  <p v-if="error">{{ error }}</p>
</template>

<style scoped>
#videos {
  width: 100%;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
  background: #eeebeb;
}
#subscriber {
  display: block;
  left: 0;
  top: 0;
  height: 400px;
}
#publisher {
  height: 400px;
  bottom: 10px;
  left: 10px;
  border: 3px solid white;
  border-radius: 3px;
}
</style>
